import createLucideIcon from '../createLucideIcon';

const Disc = createLucideIcon('Disc', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
]);

export default Disc;
